import React, {Component} from 'react';
import {observable, action, makeObservable} from 'mobx';
import {observer} from 'mobx-react';

//helpers
import omit from 'lodash/omit';
import {styleable} from 'decorators';
import {isGif} from 'utils/media-utils';

//components
import CloudinaryPicture from 'components/CloudinaryPicture';

//styled-components
import {CloudinaryPictureWithControls, RefreshButton, RefreshIcon} from './styles';

@observer
@styleable
class CloudinaryPictureWithControlsComponent extends Component {
  @observable restartAnimation = true;

  constructor(props) {
    super(props);
    makeObservable(this);
  }

  render() {
    const {src} = this.props;
    const forwardedProps = omit(this.props, 'className');

    if (isGif(src)) {
      return (
        <CloudinaryPictureWithControls>
          <CloudinaryPicture {...forwardedProps} restartAnimation={this.restartAnimation} />
          <RefreshButton onClick={this.toggleRefresh}>
            <RefreshIcon />
          </RefreshButton>
        </CloudinaryPictureWithControls>
      );
    }

    return <CloudinaryPicture {...forwardedProps} />;
  }

  @action
  toggleRefresh = () => {
    this.restartAnimation = !this.restartAnimation;
  };
}

export default CloudinaryPictureWithControlsComponent;
